import React, { Fragment } from 'react';

import t from '../../../labels/labelling-utils';
import { MatchPhase } from '../../../typings/match';
import { IReportsHomeMatch } from '../../../typings/match-reports';
import { makeClassNames } from '../../../utils/styles';
import MatchDataRow from '../../atoms/match-data-row/match-data-row';
import MatchTableHead from '../../atoms/match-table-head/match-table-head';
import MatchCtaRow from '../../molecules/match-cta-row/match-cta-row';
import MatchRow from '../../molecules/match-row/match-row';

import './reports-home-table.scss';

export interface IReportsHomeTable {
  reportsDetailsUrl?: string;
  matchList: IReportsHomeMatch[];
  round: string | number;
  competitionPhase?: MatchPhase; // FIXME: REAL BE data has COMPETITIONPHASE here -> we use it the correct way?
}

const classNames = () =>
  makeClassNames({
    reportsHomeTable: 'reports-home-table',
  });

const ReportsHomeTable = ({ reportsDetailsUrl, matchList, round }: IReportsHomeTable) => {
  const cn = classNames();

  return (
    <Fragment>
      <table className={cn.reportsHomeTable}>
        <MatchTableHead />
        <tbody>
          <MatchDataRow title={String(round)} />
          {matchList.map((match: IReportsHomeMatch) => (
            <MatchRow
              {...match}
              label={match.statusLabel}
              link={match.reportUrl || ''}
              key={match.id ?? match.matchId}
              cta={t('reports.view.match.votes')}
              type="results"
              linkArialabel={`Vai alle pagelle di ${match.home.name} - ${match.away.name}`}
            />
          ))}
          {reportsDetailsUrl && <MatchCtaRow href={reportsDetailsUrl}>{t('reports.view.all.match.votes')}</MatchCtaRow>}
        </tbody>
      </table>
    </Fragment>
  );
};

export default ReportsHomeTable;
